export default __webpack_public_path__ + "static/media/bg_working.4a865373.jpg";